import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../app.state';
import { HttpClient } from '@angular/common/http';
import { selectConfig } from '../../modules/config/config.selector';
import { Observable } from 'rxjs/Observable';
import { UserProfile } from '../model/user-profile.model';
import { selectUrlParams } from '../../modules/url-params/url-params.selector';
import { ConfigModel } from '../../modules/config/config.model';
import { UrlParams } from '../../modules/url-params/model/url-params.model';
import { AbstractRestClient } from './abstract-rest-client.service';

import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/combineLatest';

/**
 * Service handling user details
 */
@Injectable()
export class UserRestClient extends AbstractRestClient {

    netbankingUrl: string;

    constructor(private http: HttpClient, private store: Store<AppState>) {
        super();

        this.store.select(selectConfig)
            .combineLatest(this.store.select(selectUrlParams))
            .filter(([config, urlParams]: ([ConfigModel, UrlParams])) => !!config  &&  !!urlParams)
            .subscribe(([config, urlParams]: ([ConfigModel, UrlParams])) => {
                this.netbankingUrl = config ? config.apiUrl.netbanking : null;
                this.init(urlParams.access_token, config.webApiKey, urlParams.lang);
            });
    }

    /**
     * Function retrieves user profile from server.
     *
     * see https://netbankingv3.docs.apiary.io/#reference/profile/profile/current-user-profile
     *
     * @return {Observable<UserProfile>}
     */
    public loadUserProfile(): Observable<UserProfile> {
        return this.http.get<UserProfile>(this.netbankingUrl + '/my/profile', { headers: this.headers() });
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/services/user-rest-client.service.ts